// removed by extract-text-webpack-plugin
module.exports = {"title":"DmcaSuccess_title_1PO-v","prompt":"DmcaSuccess_prompt_uN3PX","iconContainer":"DmcaSuccess_iconContainer_2G7tz","icon":"DmcaSuccess_icon_21MBS"};